import {useEffect, useState} from "react";

export const usePointCloud = (potreeViewer, pointCloudUrl, projectName, fitScreen) => {
    const [projection, setProjection] = useState(null);
    useEffect(() => {
        if (!potreeViewer || !pointCloudUrl) return;

        window.Potree.loadPointCloud(pointCloudUrl, projectName, (e) => {
            let pointcloud = e.pointcloud;
            let material = pointcloud.material;

            material.activeAttributeName = "rgba";
            material.minSize = 2;
            material.pointSizeType = window.Potree.PointSizeType.ADAPTIVE;

            potreeViewer.scene.addPointCloud(pointcloud);
            if(fitScreen)
                potreeViewer.fitToScreen(0.1);
            setProjection(pointcloud.projection);
        });
    }, [potreeViewer, pointCloudUrl, projectName, fitScreen]);

    return {
        projection,
    };
};
